import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "selectAll", "actionBar", "count"]

  connect() {
    this.updateUI()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(cb => cb.checked = checked)
    this.updateUI()
  }

  toggle() {
    this.updateUI()
  }

  updateUI() {
    const checked = this.checkboxTargets.filter(cb => cb.checked)
    const total = this.checkboxTargets.length

    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = checked.length === total && total > 0
      this.selectAllTarget.indeterminate = checked.length > 0 && checked.length < total
    }

    if (this.hasActionBarTarget) {
      this.actionBarTarget.classList.toggle("hidden", checked.length === 0)
    }

    if (this.hasCountTarget) {
      this.countTarget.textContent = checked.length
    }
  }

  get selectedIds() {
    return this.checkboxTargets
      .filter(cb => cb.checked)
      .map(cb => cb.value)
  }
}
